// ============================================================================
// BackButton.tsx — ЕДИНАЯ кнопка «Назад» платформы (иконка стрелки, без
// подписи). Используется в шапке окна (UniversalWindow) и в шапке оболочки
// (ShellHeader) — один визуальный язык, тач-таргет 40px.
// ============================================================================

import { ChevronLeft } from 'lucide-react';

interface BackButtonProps {
  onClick: () => void;
  /** Подпись/tooltip (по умолчанию «Назад»). */
  title?: string;
  className?: string;
}

export function BackButton({ onClick, title = 'Назад', className = '' }: BackButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      title={title}
      aria-label={title}
      className={`flex h-10 w-10 shrink-0 cursor-pointer items-center justify-center rounded-md text-muted-foreground hover:bg-muted hover:text-foreground transition-colors ${className}`}
    >
      <ChevronLeft className="h-6 w-6" />
    </button>
  );
}
